import { CFormInput } from "@coreui/react";
import NiceModal from "@ebay/nice-modal-react";
import { ContactSupportOutlined } from "@mui/icons-material";
import { Container } from "@mui/material";
import { bffRequester } from "App";
import Dummy from "components/Dummy";
import P from "components/P";
import CustomButton from "components/buttons/CustomButton";
import InputText from "components/inputs/signUp/InputText";
import FlexChild from "layouts/flex/FlexChild";
import VerticalFlex from "layouts/flex/VerticalFlex";
import Center from "layouts/wrapper/Center";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

function TestPage() {
    const [result, setResult] = useState('');
    const inputs = useRef([]);
    const formRef = useRef();
    const navigate = useNavigate();
    const [tokenData, setTokenData] = useState();

    useEffect(() => {
        // NiceModal.show("paymentComplete")
    },[])


    const passOnClick = async () => {
        // navigate("/admin/mokRequest");
        try {
            const result = await bffRequester.getToken((result => {
                
                setTokenData(result);
            }))
            passRequestClick();
        } catch {
            console.error('getToken에서 오류가 발생했습니다:');
        }

    }
    const smsOnClick = async () => {
        // navigate("/admin/mokRequest");
        try {
            const result = await bffRequester.getToken((result => {
                
                setTokenData(result);
            }))
            smsRequestClick();
        } catch {
            console.error('getToken에서 오류가 발생했습니다:');
        }

    }
    const passRequestClick = (event) => {


        let token = {
            "encryptMOKToken": tokenData.encryptMOKToken,
            "publicKey": tokenData.publicKey
        }
        let jsonData = JSON.stringify(token);
        


        let data = {
            "serviceType": inputs.current[0].getValue(),
            "providerid": inputs.current[1].getValue(),
            "reqAuthType": inputs.current[2].getValue(),
            "usageCode": inputs.current[3].getValue(),
            "userName": inputs.current[5].getValue(),
            "userPhoneNum": inputs.current[6].getValue(),
            "retTransferType": inputs.current[4].getValue(),
            "normalFlag": "Y",
            "MOKAuthRequestData": jsonData
        }
        
        bffRequester.apiRequest(data, (result) => {
            
            NiceModal.show("confirm", { data: result, token: tokenData })
        })
    }
    const smsRequestClick = (e) => {
        let token = {
            "encryptMOKToken": tokenData.encryptMOKToken,
            "publicKey": tokenData.publicKey
        }
        let jsonData = JSON.stringify(token);
        
        let data = {
            "serviceType": inputs.current[0].getValue(),
            "providerid": inputs.current[1].getValue(),
            "reqAuthType": inputs.current[2].getValue(),
            "usageCode": inputs.current[3].getValue(),
            "userName": inputs.current[5].getValue(),
            "userPhoneNum": inputs.current[6].getValue(),
            "userBirthday": inputs.current[8].getValue(),
            "userGender": inputs.current[9].getValue(),
            "userNation": inputs.current[10].getValue(),
            "sendMsg": inputs.current[11].getValue(),
            "replyNumber": inputs.current[12].getValue(),
            "retTransferType": inputs.current[4].getValue(),
            "normalFlag": "Y",
            "MOKAuthRequestData": jsonData
        }
        
        bffRequester.apiRequest(data, (result) => {
            NiceModal.show("confirm", { data: result, token: tokenData })
        })

    }
    const inputStyle = {
        border: "none",
        boxShadow: "none",
        borderRadius: "0",
        fontSize: "15px",
        padding: "0 20px",
        color: "var(--font-color)",
        height: "50px",
    }


    return (
        <Container>
            <Container maxWidth={1200}>

                <FlexChild>
                    <Center>
                        <P color={"#000000"} size={50}>본인인증 테스트</P>
                    </Center>
                    <Dummy height={"150px"} />
                    <FlexChild>
                        <form ref={formRef} method="post">
                            <InputText ref={el => (inputs.current[0] = el)} id="serviceType" name="serviceType" placeHolder={"telcoAuth"} value={"telcoAuth"} />
                            <InputText ref={el => (inputs.current[1] = el)} id="providerid" name="providerid" placeHolder={"SKT, KT, LGU, SKTMVNO, KTMVNO, LGUMVNO"} />
                            <P>통신사명을 적어주세요 "SKT","KT","LGU","SKTMVNO","KTMVNO","LGUMVNO" 뒤에 3개는 알뜰폰 통신사</P>
                            <InputText ref={el => (inputs.current[2] = el)} id="reqAuthType" name="reqAuthType" placeHolder={"PASS"} />
                            <P>PASS 면 PASS, 문자메세지면 SMS</P>
                            <InputText ref={el => (inputs.current[3] = el)} id="usageCode" name="usageCode" placeHolder={"01001"} />
                            <P>서비스 이용코드는 01005 입력해주세요</P>
                            <InputText ref={el => (inputs.current[4] = el)} id="retTransferType" name="retTransferType" placeHolder={"MOKResult"} value={"MOKResult"} />
                            <InputText ref={el => (inputs.current[5] = el)} id="userName" name="userName" placeHolder={"이름 : (홍길동) 실명을 입력하셔야합니다"} />
                            <InputText ref={el => (inputs.current[6] = el)} id="userPhoneNum" name="userPhoneNum" placeHolder={"숫자만 (-제외)"} />
                            <InputText ref={el => (inputs.current[7] = el)} id="arsCode" name="arsCode" placeHolder={""} />
                            <InputText ref={el => (inputs.current[8] = el)} id="userBirthday" name="userBirthday" placeHolder={"20000101"} />
                            <P>생년월일 예시 : 20001101</P>
                            <InputText ref={el => (inputs.current[9] = el)} id="userGender" name="userGender" placeHolder={"남자 : 1, 여자 : 2"} />
                            <InputText ref={el => (inputs.current[10] = el)} id="userNation" name="userNation" placeHolder={"내국인 : 0, 외국인 : 1"} />
                            <InputText ref={el => (inputs.current[11] = el)} id="sendMsg" name="sendMsg" placeHolder={"본인확인 인증번호[000000]를 화면에 입력해주세요."} value={"본인확인 인증번호[000000]를 화면에 입력해주세요."} />
                            <P>문자메세지 화면에 나타날 글자</P>
                            <InputText ref={el => (inputs.current[12] = el)} id="replyNumber" name="replyNumber" placeHolder={"15880000"} />
                            <P>어떤 번호로 문자를 보낼지</P>
                            <input type="hidden" id="MOKAuthRequestData" name="MOKAuthRequestData" value='' /><br />
                            <input type="hidden" id="normalFlag" name="normalFlag" value='Y' /><br />
                            {/* <CustomButton text={"PASS요청하기"} onClick={passRequestClick} /> */}
                            {/* <CustomButton text={"SMS요청하기"} onClick={smsRequestClick} /> */}
                        </form>
                    </FlexChild>
                    <Dummy height={"15px"} />
                    <Center>
                        <CustomButton text={"PASS요청하기"} onClick={passOnClick} />
                    </Center>
                    <Center>
                        <CustomButton text={"SMS요청하기"} onClick={smsOnClick} />
                    </Center>
                </FlexChild>
            </Container>
        </Container >
    );
}

export default TestPage;